/* eslint-disable no-magic-numbers */
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Input, InputAdornment, styled } from "@mui/material";

import GrayRoundButton from "components/buttons/GrayRoundButton";
import { IAppState } from "store/app-state";
import colors, { sizes } from "theme/themeConstants";
import { ITag } from "services/types";
import { fetchAllTags } from "store/explore/explore-action";
import InputKeyboardSingleChar from "components/UI/InputKeyboardSingleChar";
import { TagList, TrendingTags } from "components/widgets";

import { ReactComponent as ArrowLeftAdornment } from "components/icons/arrowLeftAdornment.svg";
import searchIcon from "components/icons/searchIcon.svg";

import "../common.scss";
import "./styles.scss";

import { WithSideAds } from "../../components/ads";
import { ContentPageSkyscraperEnum } from "../../components/ads/config/units/contentPageSkyscraper";
import { FooterAds } from "../../components/ads/FooterAds";

export const CategoriesPage = () => {
  const { letter } = useParams();
  const tags = useSelector((state: IAppState) => state.explore.tags);
  const [currentSearchValue, setCurrentSearchValue] = useState("");
  const [selectedChar, setSelectedChar] = useState<string | null>(letter ? letter.toUpperCase() : null);
  const tagsLoading = useSelector((state: IAppState) => state.explore.tagsLoading);
  const [allTagsToRender, setAllTagsToRender] = useState((tags ?? []).slice(0, 150));
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchAllTags());

    if (letter) {
      document.title = `Porn Gif Categories with ${letter.toUpperCase()} | RedGIFs`;
    } else {
      document.title = "Top Porn Gif Categories | RedGIFs";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [letter]);

  useEffect(() => {
    if (letter) {
      setSelectedChar(letter.toUpperCase());
    }
  }, [letter]);

  useEffect(() => {
    if (allTagsToRender.length === 0) { setAllTagsToRender(tags.slice(0, 150)); }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tags.length]);

  useEffect(() => {
    if (selectedChar !== null) {
      let tempTags = tags.filter((tag: ITag) => tag.name[0].toUpperCase() === selectedChar);
      if (currentSearchValue.length) {
        tempTags = tempTags.filter((tag: ITag) => tag.name.toLowerCase().includes(currentSearchValue.toLowerCase()));
      }
      setAllTagsToRender(tempTags.slice(0, 150));
    } else {
      // setAllTagsToRender(tags.slice(0, 150));
      setAllTagsToRender([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedChar, tags.length]);

  const handleGoBackButtonClick = () => {
    navigate(-1);
  };

  const searchTagHandler = ({ target: { value } }: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentSearchValue(value);
    let searchedTags = tags.filter((tag: ITag) => tag.name.toLowerCase().includes(value.toLowerCase()));
    if (selectedChar !== null) {
      searchedTags = searchedTags.filter((tag: ITag) => tag.name[0].toUpperCase() === selectedChar);
    }

    setAllTagsToRender(searchedTags.slice(0, 150));
  };

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
        ]}
      >
        <Container className="narrow page categoriesPage">

          <div style={{ display: "flex", alignItems: "center", marginBottom: "1.5rem" }}>

            <GrayRoundButton img={<ArrowLeftAdornment />} onClick={handleGoBackButtonClick} />
            <h1 style={{
              fontSize: "20px",
              fontWeight: 500,
              display: "inline",
              marginLeft: "0.5rem",
            }}>Trending Gif Categories</h1>
          </div>

          <TrendingTags />

          <div style={{
            margin: "1rem 0",
          }}>
            <h1 style={{
              fontSize: "20px",
              fontWeight: 500,
            }}>All Tags</h1>
          </div>

          <InputKeyboardSingleChar currentSelectedChar={selectedChar} />

          <StyledInputContainer >
            <Input
              id="global-search-input"
              onChange={searchTagHandler}
              value={currentSearchValue}
              disableUnderline
              autoComplete="off"
              size="small"
              inputProps={{
                style: {
                  border: `1px solid ${colors.lightGray}`,
                  width: "-webkit-fill-available",
                  height: "40px",
                  paddingLeft: "1rem",
                  color: colors.white,
                  backgroundColor: colors.backgroundBlack,
                  borderRadius: "12px",
                  padding: "6 10px",
                  fontWeight: 400,
                  fontSize: "14px",
                  lineHeight: "22px",
                },
                startAdornment: (
                  <InputAdornment position="start" sx={{ "& img": { width: "16px", height: "16px" } }}>
                    <img src={searchIcon} alt="search" />
                  </InputAdornment>
                )
              }}
              placeholder="Search" />
          </StyledInputContainer>

          {tagsLoading ? (
            <div style={{ maxHeight: "14px" }}>
              <CircularProgress sx={{ color: colors.redPink }} size={12} />
            </div>
          ) : (
            <TagList tags={allTagsToRender} counts={true} />
          )}

        </Container>
      </WithSideAds>
      <FooterAds/>
    </Fragment>
  );
};

const Container = styled("div")({
  width: "-webkit-fill-available",
  "@-moz-document url-prefix()": {
    width: "-moz-available",
  },
  "@media screen and (min-width: 900px)": {
    marginBottom: "1rem",
    maxWidth: sizes.containerSize,
  }
});

const StyledInputContainer = styled("div")({
  marginTop: "1rem",
  marginBottom: "2rem",
  width: "-webkit-fill-available",
  "@-moz-document url-prefix()": {
    width: "-moz-available"
  },
  "& div": { width: "inherit" },
});
